<div class="kontainer" [style.border-top-color]="gruppefarge()">
  <div class="nummer">{{ moete().nummer }}</div>
  <div class="dato">{{ moetedato() }}</div>
</div>
